export default "__VITE_ASSET__sdSYUluh__"